import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { MaskedLines } from "@/components/Reveal";

const ease = [0.22, 1, 0.36, 1];

export const Hero = () => (
  <section className="relative overflow-hidden" data-testid="hero-section">
    <div className="starfield" aria-hidden />
    <div aria-hidden className="grid-lines pointer-events-none absolute inset-0 opacity-70" />
    <div aria-hidden className="pointer-events-none absolute left-1/2 top-[30%] h-[560px] w-[900px] max-w-[140vw] -translate-x-1/2 rounded-full bg-blue/20 blur-[160px]" />

    <div className="relative mx-auto max-w-7xl px-5 pb-4 pt-12 text-center sm:px-8 sm:pt-16 lg:pt-20">
      <motion.p className="mono-label justify-center" initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, ease }} data-testid="hero-eyebrow">
        Xpattern // Automotive pattern cutting software
      </motion.p>
      <h1 className="display mx-auto mt-6 max-w-5xl text-5xl text-white sm:text-6xl md:text-7xl lg:text-[6.5rem]" data-testid="hero-headline">
        <MaskedLines delay={0.15} lines={["Every Pattern.", "Precision cutting,", <span key="l3" className="text-cyan-glow">made simple.</span>]} />
      </h1>
      <motion.p className="mx-auto mt-7 max-w-2xl text-base leading-relaxed text-muted sm:text-lg" initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, ease, delay: 0.5 }} data-testid="hero-subcopy">
        Patterns for any vehicle at your fingertips, nested to save film and sent to the plotter you already own — for a
        fraction of what the big software companies charge.
      </motion.p>
      <motion.div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row" initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, ease, delay: 0.65 }}>
        <a href="#pricing" className="btn btn-primary" data-testid="hero-subscriptions-button">
          Subscriptions <ArrowRight size={16} />
        </a>
      </motion.div>

      <motion.div className="-mx-5 mt-10 sm:mx-auto sm:mt-12 sm:max-w-5xl lg:mt-14" initial={{ opacity: 0, y: 40 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1.1, ease, delay: 0.7 }}>
        <div className="relative" data-testid="home-demo-video-frame">
          <div aria-hidden className="pointer-events-none absolute left-1/2 top-1/2 h-[70%] w-[80%] -translate-x-1/2 -translate-y-1/2 rounded-full bg-blue/20 blur-[120px]" />
          <div className="video-blend relative">
            <video
              poster="/screens/demo-poster.jpg"
              className="block aspect-[958/485] h-auto w-full"
              autoPlay
              muted
              loop
              playsInline
              controls
              preload="auto"
              data-testid="home-demo-video"
            >
              <source src="/xpattern-demo.mp4" type="video/mp4" />
              <source src="/xpattern-demo.webm" type="video/webm" />
            </video>
          </div>
        </div>
      </motion.div>
    </div>
  </section>
);
